import React, { Component } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { ValidationHelper } from '../helpers/ValidationHelper';
import { ColourPalette } from '../styles/AppColourPalette';
import { CommonStyles } from '../styles/Styles';
import { AppTheme } from '../styles/AppTheme';
import {
  StyleSheet,
  css
} from 'aphrodite';
import { AppHelper } from '../helpers/AppHelper';

export class CheckboxComponent extends Component {
  constructor(props) {
    super(props);
    this.initialValue = this.props.value;
    this.selectAll = false;
    this.selectAllOption = AppHelper.getSelectAllOption();
    
    // Make sure we have a valid array of options
    const options = props.formField && props.formField.options ? [...props.formField.options] : [];
    
    this.state = {
      searchTerm: '',
      filteredOptions: options,
      menuOpen: false // Track whether the menu is open
    };
  }

  componentDidMount() {
    // Make sure we have options to render
    if (this.props.formField && this.props.formField.options) {
      this.setState({
        filteredOptions: [...this.props.formField.options]
      });
    }
  }

  componentDidUpdate(prevProps) {
    // If options change, update filtered options
    if (prevProps.formField.options !== this.props.formField.options) {
      this.setState({
        filteredOptions: this.props.formField.options
      });
    }
  }

  isAllSelected = () => {
    const values = this.props.value;
    const selectAllKey = this.selectAllOption.key;
    if ((values.length === this.props.formField.options.length - 1) &&
      !values.includes(selectAllKey) &&
      !this.props.disableSelectAll) {
      values.push(selectAllKey);
      this.selectAll = true;
      this.setValue(values);
    }
  }

  setValue(value) {
    this.props.setValue(value, this.props.formField.key);
  }

  change = (e, item) => {
    const selectAllKey = this.selectAllOption.key;
    if (item.key === selectAllKey || item.props.value === selectAllKey) {
      this.selectAllValues();
    } else {
      if ((e.target.value.length === this.props.formField.options.length - 1) &&
        !e.target.value.includes(selectAllKey) &&
        !this.props.disableSelectAll) {
        e.target.value.push(selectAllKey);
        this.setValue(e.target.value);
      } else {
        if (e.target.value.includes(selectAllKey)) {
          e.target.value = e.target.value.filter(function (value) {
            return value !== selectAllKey;
          });
        }
        this.setValue(e.target.value);
      }
    }
  }

  selectAllValues = () => {
    const value = [];
    if (this.selectAll) {
      for (const f of this.props.formField.options) {
        if (f.key !== 'selectAll') {
          value.push(f.key);
        }
      }
      value.push(this.selectAllOption.key);
      this.setValue(value);
    } else {
      this.setValue(value);
    }
  }

  filterOptions = (options, searchTerm) => {
    if (!searchTerm || searchTerm === '') return options;
    
    return options.filter(option => {
      const name = option.name_wfh || option.name;
      return name.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }

  handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    this.setState({
      searchTerm,
      filteredOptions: this.filterOptions(this.props.formField.options, searchTerm)
    });
  }

  handleMenuOpen = () => {
    this.setState({
      searchTerm: '',
      filteredOptions: this.props.formField.options,
      menuOpen: true
    });
  }

  // Handle menu close
  handleMenuClose = () => {
    this.setState({ menuOpen: false });
  }

  render() {
    const matchesFound = this.props.formField && this.props.formField.options.some(ai => this.props.value.includes(ai.key));
    const { searchTerm, filteredOptions } = this.state;
    const optionsToDisplay = filteredOptions && filteredOptions.length > 0 ? filteredOptions : [];
    
    return (
      <FormControl
        style={this.props.inputCss}
        className={this.props.headerView ? css(Styles.multiPickerForm) : css(Styles.inputCss)}>
        {this.props.formField.label &&
          <InputLabel
            className={css(Styles.inputLabel)}
            classes={{
              shrink: css(Styles.inputLabelShrink)
            }}>
            {this.props.formField.label}
          </InputLabel>
        }
        <Select
          multiple 
          value={matchesFound ? this.props.value : []}
          onChange={(e, item) => {
            if(e.target.value.includes('selectAll')){
              this.selectAll = true;
            } else {
              this.selectAll = false;
            }
            this.change(e, item);
          }}
          onOpen={this.handleMenuOpen}
          onClose={this.handleMenuClose}
          className={this.props.headerView ? css(Styles.pickerInnerContainer) : css(Styles.dummyClass)}
          renderValue={selected => {
            return (
              <div style={{ 
                maxWidth: this.props.headerView ? 135 : 'unset', 
                overflow: 'hidden', 
                textOverflow: 'ellipsis',
              }}>
                {
                  this.props.formField.options.map(item => {
                    return (
                      selected.map((key, index) => {
                        if (key !== 'selectAll') {
                          if (selected.length - 1 === index) {
                            if (selected.length === 1) {
                              return (
                                key === item.key &&
                                [this && this.props && item.name_wfh ? item.name_wfh : item.name]
                              );
                            } else {
                              return (
                                key === item.key &&
                                [this && this.props && item.name_wfh ? item.name_wfh : item.name] + ','
                              );
                            }
                          } else {
                            return (
                              key === item.key &&
                                [this && this.props && item.name_wfh ? item.name_wfh : item.name] + ', '
                            );
                          }
                        }
                        return null;
                      }))
                  })
                }
              </div>
            );
          }}
          disabled={this.props.disabled}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left'
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left'
            },
            getContentAnchorEl: null,
            classes: {
              paper: css(CommonStyles.menuItemContainerRoot),
              list: css(CommonStyles.menuItemListContainerRoot)
            }
          }}
          input={<Input disableUnderline={true} />}
          classes={{
            selectMenu: this.props.headerView ? css(Styles.selectOrgMenu) : this.props.action === 'viewInfo' ? css(Styles.selectMenu, Styles.textFieldContentInputView) : css(Styles.selectMenu),
            icon: this.props.headerView ? css(Styles.selectIcon) : this.props.action === 'viewInfo' ? css(Styles.selectIconView) : css(Styles.selectIcon2),
          }}
        >
          <div className={css(Styles.searchContainer)}>
            <TextField
              fullWidth
              placeholder="Search..."
              value={searchTerm}
              onChange={this.handleSearchChange}
              variant="outlined"
              size="small"
              className={css(Styles.searchInput)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon className={css(Styles.searchIcon)} />
                  </InputAdornment>
                ),
              }}
              // Handle click in a way that doesn't block rendering
              onClick={(e) => {
                // Stop propagation only for the input itself
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                // Only stop propagation for key events within the search box
                e.stopPropagation();
              }}
            />
          </div>
          
          {optionsToDisplay.length > 0 ? (
            optionsToDisplay.map(item => (
              <MenuItem
                key={item.key}
                value={item.key}
                className={css(CommonStyles.menuItemContainer)}>
                <Checkbox
                  checked={this.props.value.indexOf(item.key) > -1}
                  className={css(Styles.selectCheckbox)} />
                <ListItemText primary={this && this.props && this.props.orgType && this.props.orgType === "wfhTeams" && item.name_wfh ? item.name_wfh : item.name} />
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled className={css(Styles.noResultsItem)}>
              No matches found
            </MenuItem>
          )}
        </Select>

        {
          !this.props.headerView &&
          <FormHelperText
            className={css(Styles.errorMsgStyle)}>
            {!this.props.enableValidation ? '' : ValidationHelper.validateFields(this.props.formField, this.props.value)}
          </FormHelperText>
        }
      </FormControl>
    );
  }
}

const Styles = StyleSheet.create({
  inputCss: {
    margin: 8,
    color:"#000",
    minHeight: AppTheme.formFieldHeight,
    '@media(max-width: 767px)': {
      maxWidth: window.innerWidth / 2
    },
    fontFamily:"Roboto,sans-serif !important",
  },
  inputLabel: {
    marginLeft: 8,
    opacity: 1,
    zIndex: 1,
    pointerEvents: 'none',
    '@media(max-width: 767px)': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      right: 22,
    }
  },
  inputLabelShrink: {
    right: 'unset',
    color:"#000",
  },
  selectMenu: {
    backgroundColor:"#eeeeee",
    color:"#000",
    paddingLeft: 8,
    borderRadius: 4,
    border:"0.2px solid"
  },
  textFieldContentInputView: {
    backgroundColor:"rgb(238, 238, 238) !important",
    color:"#000",
  },
  selectIcon: {
    color:"#fff",
    marginRight: 1,
  },
  selectIcon2: {
    color:"#000",
    marginRight: 1,
  },
  selectIconView: {
    color: "#fff"
  },
  selectCheckbox: {
    color: AppTheme.primaryBase
  },
  errorMsgStyle: {
    color: AppTheme.white,
    paddingLeft: 8
  },
  multiPickerForm: {
    '@media(max-width: 768px)': {
      flex: 1
    }
  },
  dummyClass: {
  },
  pickerInnerContainer: {
    color: AppTheme.white,
    marginRight: 10,
    '@media (max-width: 768px)': {
      marginRight: 0,
    }
  },
  selectOrgMenu: {
    minWidth: 150,
    maxWidth: 150,
    boxShadow:"rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px !important",
    color: AppTheme.white,
    fontSize: 15,
    padding: 7,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 5,
    '@media(max-width: 768px)': {
      minWidth: 'unset'
    }
  },
  // New styles for search functionality
  searchContainer: {
    position: 'sticky',
    top: 0,
    backgroundColor: '#fff',
    padding: '8px',
    zIndex: 1,
    borderBottom: '1px solid #ddd'
  },
  searchInput: {
    margin: '4px 0',
  },
  searchIcon: {
    color: '#757575',
  },
  noResultsItem: {
    textAlign: 'center',
    color: '#757575',
    padding: '10px 0',
  }
});